import { BRAND_PINK, PRODUCT_NAME } from "@/lib/format";

/** The one and only wordmark: Trifit.XPS · "XPS" in brand pink. */
export default function Wordmark({ size = "text-xl", withLogo = true, logoClass = "w-6 h-6" }) {
  return (
    <span className="flex items-center gap-2.5 min-w-0" data-testid="wordmark">
      {withLogo && (
        <img src="/trifit-logo.png" alt={PRODUCT_NAME} className={`${logoClass} rounded-md shrink-0`}
          onError={(e) => { e.currentTarget.style.display = "none"; }} />
      )}
      <span className={`font-heading ${size} font-black tracking-tight whitespace-nowrap`}>
        Trifit.<span style={{ color: BRAND_PINK }}>XPS</span>
      </span>
    </span>
  );
}
